<div class="modal-header border-0 pb-0">
  <div class="data-item d-flex align-items-center gap-3">
    <div class="data-icon bg-primary bg-opacity-10">
      <i class="fas fa-bell text-primary"></i>
    </div>
    <h5 class="modal-title mb-0">
      {{ id == null ? ('lumAlarmNewTitle' | translate) : ('lumAlarmEditTitle' | translate) }}
    </h5>
  </div>
  <button type="button" class="btn-close" [attr.aria-label]="'close' | translate" (click)="cancel()"></button>
</div>

<div class="modal-body pt-3">
  <div class="d-flex flex-column gap-3">

    <!-- Datos generales -->
    <div class="border rounded-3 p-3 bg-white shadow-sm">
      <div class="row g-3 align-items-end">
        <div class="col">
          <label class="form-label small mb-1" for="lumAlarmName">
            <i class="fas fa-tag text-primary me-1"></i>{{ 'name' | translate }}
          </label>
          <input type="text" class="form-control" id="lumAlarmName" name="lumAlarmName"
            [placeholder]="'lumAlarmNamePlaceholder' | translate" [(ngModel)]="cfg.name">
        </div>
        <div class="col-auto">
          <div class="d-flex align-items-center gap-2 mb-1">
            <label class="switch mb-0">
              <input type="checkbox" id="lumAlarmEnabled" name="lumAlarmEnabled" [(ngModel)]="cfg.enabled">
              <span class="slider round"></span>
            </label>
            <label class="mb-0" for="lumAlarmEnabled">{{ 'lumAlarmEnabled' | translate }}</label>
          </div>
        </div>
      </div>
    </div>

    <!-- Condición de disparo -->
    <div class="border rounded-3 p-3 bg-white shadow-sm">
      <h6 class="text-muted text-uppercase small mb-3">
        <i class="fas fa-filter text-primary me-1"></i>{{ 'lumAlarmWhen' | translate }}
      </h6>
      <div class="row g-3">
        <div class="col-12" [ngClass]="cfg.threshold_type === 'MIN_MAX' ? 'col-md-3' : 'col-md-4'">
          <label class="form-label small mb-1" for="lumAlarmVariable">{{ 'lumAlarmVariable' | translate }}</label>
          <select class="form-select" id="lumAlarmVariable" name="lumAlarmVariable"
            [(ngModel)]="variable" (ngModelChange)="onVariableChange($event)">
            <option *ngFor="let option of variableOptions" [ngValue]="option.value">
              {{ getLabelForValue(option.value) | translate }}
            </option>
          </select>
        </div>

        <div class="col-12 col-md-4">
          <label class="form-label small mb-1" for="lumAlarmCondition">{{ 'lumAlarmCondition' | translate }}</label>
          <select class="form-select" id="lumAlarmCondition" name="lumAlarmCondition" [(ngModel)]="cfg.threshold_type"
            (ngModelChange)="onThresholdTypeChange()">
            <option *ngFor="let option of thresholdTypeOptions" [ngValue]="option.value">
              {{ option.labelKey | translate }}
            </option>
          </select>
        </div>

        <div class="col-12 col-md-4" *ngIf="cfg.threshold_type !== 'MIN_MAX'; else minMaxThreshold">
          <label class="form-label small mb-1" for="lumAlarmValue">{{ 'lumAlarmValue' | translate }}</label>
          <div class="input-group">
            <input type="number" class="form-control" id="lumAlarmValue" name="lumAlarmValue"
              [min]="getLimit('threshold')?.min" [max]="getLimit('threshold')?.max" [step]="getLimit('threshold')?.step"
              [class.is-invalid]="isOutOfRange(cfg.threshold, 'threshold')"
              [(ngModel)]="cfg.threshold">
            <span class="input-group-text py-1">{{ getUnitForValue(variable) }}</span>
          </div>
        </div>

        <ng-template #minMaxThreshold>
          <div class="col-12 col-md-5">
            <label class="form-label small mb-1" for="lumAlarmMinValue">{{ 'lumAlarmValue' | translate }} ({{ getUnitForValue(variable) }})</label>
            <div class="input-group">
              <span class="input-group-text py-1">{{ 'lumAlarmThresholdMin' | translate }}</span>
              <input type="number" class="form-control" id="lumAlarmMinValue" name="lumAlarmMinValue"
                [min]="getLimit('threshold')?.min" [max]="getLimit('threshold')?.max" [step]="getLimit('threshold')?.step"
                [class.is-invalid]="isOutOfRange(cfg.threshold_min, 'threshold') || +cfg.threshold_min >= +cfg.threshold_max"
                [(ngModel)]="cfg.threshold_min">
              <span class="input-group-text py-1">{{ 'lumAlarmThresholdMax' | translate }}</span>
              <input type="number" class="form-control" id="lumAlarmMaxValue" name="lumAlarmMaxValue"
                [min]="getLimit('threshold')?.min" [max]="getLimit('threshold')?.max" [step]="getLimit('threshold')?.step"
                [class.is-invalid]="isOutOfRange(cfg.threshold_max, 'threshold') || +cfg.threshold_min >= +cfg.threshold_max"
                [(ngModel)]="cfg.threshold_max">
            </div>
          </div>
        </ng-template>
      </div>
    </div>

    <!-- Acción -->
    <div class="border rounded-3 p-3 bg-white shadow-sm">
      <h6 class="text-muted text-uppercase small mb-3">
        <i class="fas fa-arrow-right text-primary me-1"></i>{{ 'lumAlarmThen' | translate }}
      </h6>
      <div class="row g-3">
        <div class="col-12 col-md-6">
          <label class="form-label small mb-1">{{ 'lumAlarmAction' | translate }}</label>
          <div class="btn-group w-100" role="group" [attr.aria-label]="'lumAlarmAction' | translate">
            <ng-container *ngFor="let option of actionComponents">
              <input class="btn-check" type="radio" name="lumAlarmActionComponent"
                [id]="'lumAlarmActionComponent-' + option.value" [value]="option.value"
                [(ngModel)]="actionComponent" (ngModelChange)="onActionComponentChange($event)">
              <label class="btn btn-outline-primary" [for]="'lumAlarmActionComponent-' + option.value">
                <i class="fas me-1" [class.fa-plug]="option.value === 'relay'"
                  [class.fa-paper-plane]="option.value === 'Notification'"></i>
                {{ option.labelKey | translate }}
              </label>
            </ng-container>
          </div>
        </div>

        <div class="col-12 col-md-6" *ngIf="cfg.trigger_actions?.length">
          <label class="form-label small mb-1">{{ 'lumAlarmComponentRelay' | translate }}</label>
          <div class="btn-group w-100" role="group" [attr.aria-label]="'lumAlarmComponentRelay' | translate">
            <ng-container *ngFor="let option of actionCommands">
              <input class="btn-check" type="radio" name="lumAlarmActionCommand"
                [id]="'lumAlarmActionCommand-' + option.value" [value]="option.value"
                [(ngModel)]="cfg.trigger_actions[0].action">
              <label class="btn btn-outline-secondary d-inline-flex align-items-center justify-content-center gap-1"
                [for]="'lumAlarmActionCommand-' + option.value">
                <svg viewBox="0 0 24 24" width="20" height="20" class="flex-shrink-0" aria-hidden="true">
                  <path [attr.d]="getRelaySwitchPath(option.value)" fill="none" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round" />
                </svg>
                {{ option.labelKey | translate }}
              </label>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <!-- Opciones avanzadas: detección (histéresis, retardo) y funcionamiento (lectura, rearme) -->
    <div class="border rounded-3 p-3 bg-white shadow-sm">
      <h6 class="text-muted text-uppercase small mb-3">
        <i class="fas fa-sliders-h text-primary me-1"></i>{{ 'lumAlarmAdvancedOptions' | translate }}
      </h6>
      <div class="row g-3">
        <div class="col-12 col-md-6" *ngIf="cfg.threshold_type !== 'MIN_MAX'; else minMaxHysteresis">
          <label class="form-label small mb-1" for="lumAlarmHysteresis">{{ 'lumAlarmHysteresis' | translate }}</label>
          <div class="input-group">
            <input type="number" class="form-control" id="lumAlarmHysteresis" name="lumAlarmHysteresis"
              [min]="getLimit('hysteresis')?.min" [max]="getLimit('hysteresis')?.max" [step]="getLimit('hysteresis')?.step"
              [class.is-invalid]="isOutOfRange(cfg.hysteresis, 'hysteresis')"
              [(ngModel)]="cfg.hysteresis">
            <span class="input-group-text py-1">{{ getUnitForValue(variable) }}</span>
          </div>
        </div>

        <ng-template #minMaxHysteresis>
          <div class="col-12 col-md-6">
            <label class="form-label small mb-1" for="lumAlarmHysteresisMin">{{ 'lumAlarmHysteresis' | translate }} ({{ getUnitForValue(variable) }})</label>
            <div class="input-group">
              <span class="input-group-text py-1">{{ 'lumAlarmThresholdMin' | translate }}</span>
              <input type="number" class="form-control" id="lumAlarmHysteresisMin" name="lumAlarmHysteresisMin"
                [min]="getLimit('hysteresis')?.min" [max]="getLimit('hysteresis')?.max" [step]="getLimit('hysteresis')?.step"
                [class.is-invalid]="isOutOfRange(cfg.hysteresis_min, 'hysteresis')"
                [(ngModel)]="cfg.hysteresis_min">
              <span class="input-group-text py-1">{{ 'lumAlarmThresholdMax' | translate }}</span>
              <input type="number" class="form-control" id="lumAlarmHysteresisMax" name="lumAlarmHysteresisMax"
                [min]="getLimit('hysteresis')?.min" [max]="getLimit('hysteresis')?.max" [step]="getLimit('hysteresis')?.step"
                [class.is-invalid]="isOutOfRange(cfg.hysteresis_max, 'hysteresis')"
                [(ngModel)]="cfg.hysteresis_max">
            </div>
          </div>
        </ng-template>

        <div class="col-12 col-md-6">
          <label class="form-label small mb-1" for="lumAlarmHoldFor">{{ 'lumAlarmHoldFor' | translate }}</label>
          <div class="input-group">
            <input type="number" class="form-control" id="lumAlarmHoldFor" name="lumAlarmHoldFor"
              [min]="getLimit('trigger_delay')?.min" [max]="getLimit('trigger_delay')?.max" [step]="getLimit('trigger_delay')?.step"
              [class.is-invalid]="isOutOfRange(msToSeconds(cfg.trigger_delay), 'trigger_delay')"
              [ngModel]="msToSeconds(cfg.trigger_delay)"
              (ngModelChange)="cfg.trigger_delay = secondsToMs($event)">
            <span class="input-group-text py-1">{{ 'lumAlarmUnitSeconds' | translate }}</span>
          </div>
        </div>

        <div class="col-12 col-md-6">
          <label class="form-label small mb-1" for="lumAlarmCheckInterval">{{ 'lumAlarmCheckEvery' | translate }}</label>
          <div class="input-group">
            <input type="number" class="form-control" id="lumAlarmCheckInterval" name="lumAlarmCheckInterval"
              min="1" [ngModel]="msToSeconds(cfg.read_interval)"
              (ngModelChange)="cfg.read_interval = secondsToMs($event)">
            <span class="input-group-text py-1">{{ 'lumAlarmUnitSeconds' | translate }}</span>
          </div>
        </div>

        <div class="col-12 col-md-6">
          <div class="d-flex align-items-center gap-2 mb-1">
            <label class="switch-sm mb-0">
              <input type="checkbox" id="lumAlarmAutoClear" name="lumAlarmAutoClear" [(ngModel)]="cfg.auto_clean">
              <span class="slider round"></span>
            </label>
            <label class="small mb-0" for="lumAlarmAutoClear">{{ 'lumAlarmAutoClear' | translate }}</label>
          </div>
          <div class="input-group">
            <span class="input-group-text py-1">{{ 'lumAlarmAfter' | translate }}</span>
            <input type="number" class="form-control" id="lumAlarmClearAfter" name="lumAlarmClearAfter"
              min="0" [ngModel]="msToSeconds(cfg.auto_clean_interval_ms)"
              (ngModelChange)="cfg.auto_clean_interval_ms = secondsToMs($event)" [disabled]="!cfg.auto_clean">
            <span class="input-group-text py-1">{{ 'lumAlarmUnitSeconds' | translate }}</span>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>

<div class="modal-footer border-0 pt-0">
  <button type="button" class="btn btn-outline-secondary" (click)="cancel()">
    {{ 'cancel' | translate }}
  </button>
  <button type="button" class="btn btn-primary" (click)="save()" [disabled]="!cfg.name || !variable || !actionComponent || hasInvalidValues">
    {{ 'lumAlarmSave' | translate }}
  </button>
</div>
